import React from 'react'
import logo from "../../assets/images/logo.png";
import ReactPlayer from "react-player";
import loaderVideo from "../../assets/images/animation.mp4";

import '../loader/LoadingPage.css'
const LoadingPage = () => {
  return (
    <>
      <div className="loading-page">
        <div className="loading-content">
            {/* <ReactPlayer
              url={loaderVideo}
              playing
              loop
              muted
              width="180px"
              height="180px"
            /> */}
            <div className="loading">
              <div></div>
              <div></div>
            </div>
            <p>Loading...</p>
        </div>
      </div>
    </>
  )
}

export default LoadingPage